import BanquanRegist from './BanquanRegist'
import BanquanCopywrit from './BanquanCopywrit'
export default [
    {
        name: 'BanquanRegist',
        path: 'BanquanRegist',
        redirect:{name:"BqAll"},
        component: () => import('@/pages/BigData/CopyrightModule/BanquanRegist'),
        meta: { title: '版权【登记案件】申报', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
        children:[...BanquanRegist]
    },
    {
        name: 'BanquanCopywrit',
        path: 'BanquanCopywrit',
        redirect:{name:'CbQAll'},
        component: () => import('@/pages/BigData/CopyrightModule/BanquanCopywrit'),
        meta: { title: '版权【文案】撰写/翻译', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
        children:[...BanquanCopywrit]
    },
   
]